<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <!-- <v-btn @click="test"></v-btn> -->
        </v-container>
    </v-app>
</template>
<script>
import {db,fieldValue} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{

        }
    },
    methods:{
        test(){
            db.collection("invoice").where("status", "==", "Open").where("payMentStatus", "==", "Not paid yet")
            .where("down", ">", 0).get()
            .then(query=>{
                let arr = []
                let i = 0
                query.forEach(doc=>{
                    arr.push({ ...doc.data(), id: query.docs[i].id })
                    i++
                })
                // console.log(arr)
                arr.forEach(rec=>{
                    db.collection("invoice").doc(rec.id).update({
                        payMentStatus: 'Paid'
                    })
                    .then(()=>{
                        console.log(rec.invNo)
                    })
                })
            })
        },

        // เพิ่มยอดยกมา
        addGl(){
            db.collection("generalLedger").add({
                accId: '112001',
                accName: 'Accounts Receivable',
                credit: 0,
                debit: 23166709,
                desc: '',
                glDate: '2019-03-31',
                glNo: '',
                refNo: '',
                remark: ''
            })
            .then(()=>{
                console.log("Success.")
            })
        },
        addCounter(){
            let date = new Date().toISOString().substr(0,10)
            let year = date.substr(0,4)
            if(date < year + "-" + "02"){
                db.collection("counter").doc(year).get()
                .then(doc=>{
                    if(doc.data() == undefined){
                        db.collection("counter").doc(year).set({
                            cn: 0,
                            cp: 0,
                            dn: 0,
                            gr: 0,
                            in: 0,
                            invN: 0,
                            invV: 0,
                            jv: 0,
                            lv: 0,
                            pu: 0,
                            pv: 0,
                            rv: 0,
                            soD: 0,
                            soF: 0,
                            soM: 0,
                            soW: 0,
                            cd: 0,
                            rt: 0,
                        })
                    }
                })
            }
        },

        newYear(){
            let nextYear = new Date().toISOString().substr(0,4)
            db.collection("code").doc("runYear").update({
                year: fieldValue.arrayUnion(nextYear)
            })
        }
    },
    mounted(){
        this.addCounter()
        this.newYear()
    }
}
</script>
